"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class InvoiceLine {
}
exports.default = InvoiceLine;
//# sourceMappingURL=InvoiceLine.js.map